import * as Yup from 'yup';

const organisationYearWiseValidationSchema = Yup.object().shape({
  organizationShare: Yup.string().typeError().required().max(100).min(0),
});

export const mapValidationSchema = Yup.object().shape({
  organizationMap: Yup.array().of(
    Yup.object().shape({
      organisationYearWise: organisationYearWiseValidationSchema,
    })
  ),
});
